module.exports = __webpack_public_path__ + "static/media/BlinkExam.c1bf0a4b.svg";